import './App.css';
import Footer from './components/footer/Footer';
import Home from './container/Home/Home';

function App() {
  return (
    <div className="app">
      <Home />
      <Footer />
    </div>
  );
}

export default App;
